import React from "react"
import Alert from "@material-ui/lab/Alert"
import { Button } from "@material-ui/core"
import { useCallback } from "react"
import { navigate } from "gatsby"
import { isLoggedIn } from "../services/auth"

const LoginRequiredAlert = () => {
    if (isLoggedIn()) return <></>
    const handleClick = useCallback(() => navigate("/login"), [navigate])
    return <Alert severity="warning" action={<Button variant="outlined" onClick={handleClick}>Se connecter</Button>}>Pour accéder à l'intégralité de ce contenu, vous devez être connectés.</Alert>
}
export default LoginRequiredAlert
